import React from "react";
import { Container, Row, Col } from "react-grid-system";
import { Field, useForm } from "react-final-form";
import { motion, AnimateSharedLayout } from "framer-motion";

import DatePicker from "../../components/DatePicker";
import ZipCodeField from "../../components/ZipCodeField";
import ConditionalField from "../../components/ConditionalField";
import {
  Error,
  required,
  requiredIfNot,
  composeValidators,
  isLongDistance,
} from "../../components/Validation";

const MoveDetails = () => {
  const {
    mutators: { clearMovingTo },
  } = useForm();

  return (
    <AnimateSharedLayout>
      <Container className="form-fields row header-label">
        <Row>
          <Col sm={12} md={6} className="form-fields__block zip-code">
            <label htmlFor="moving_from">
              I&apos;m moving from:
              <ZipCodeField name="moving_from" validate={required()} />
            </label>
            <Error name="moving_from" />
            <motion.div layout>
              <label className="checkbox-wrap" htmlFor="international">
                <Field
                  id="international"
                  name="international"
                  component="input"
                  type="checkbox"
                  value="true"
                  className="checkbox"
                  parse={(v) => {
                    if (v[0]) {
                      clearMovingTo();
                    }
                    return !!v[0];
                  }}
                  format={(v) => [v ? "true" : "false"]}
                />
                I am moving internationally
              </label>
            </motion.div>
          </Col>
          <Col sm={12} md={6} className="form-fields__block zip-code">
            <ConditionalField when="international" isNot>
              <label htmlFor="moving_to">
                I&apos;m moving to:
                <ZipCodeField
                  name="moving_to"
                  validate={composeValidators(
                    requiredIfNot("international"),
                    isLongDistance
                  )}
                />
              </label>
              <Error name="moving_to" />
            </ConditionalField>
          </Col>
          <Col
            sm={12}
            className="form-fields__block"
            style={{ paddingTop: 32 }}
          >
            <motion.div layout>
              <label htmlFor="move_date">
                When are you moving?
                <Field name="move_date" component={DatePicker} />
              </label>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </AnimateSharedLayout>
  );
};

export default MoveDetails;
